module.exports = __webpack_public_path__ + "img/ss_ye-08.ff876a97.jpg";